import { ArrowBackIos } from '@mui/icons-material';
import { Box, MenuItem, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import HelpCenterLink from '../../atoms/HelpCenterLink';
import { routes } from '../../routes';

export const ResultNav = (): JSX.Element => {
  const navigate = useNavigate();
  const reportsPage = routes.filter((route) => route.title === 'Reports')[0];

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <MenuItem onClick={() => navigate(reportsPage.path!)}>
          <ArrowBackIos />
          <Typography sx={{ cursor: 'pointer', fontSize: 16, opacity: 0.5 }}>
            {reportsPage.title.toUpperCase()}
          </Typography>
        </MenuItem>
        <HelpCenterLink />
      </Box>
    </>
  );
};
